module.exports = __webpack_public_path__ + "static/media/restaurantManagementImg.6ae0c333.svg";